import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PricingConstant, PricingPlanType } from 'src/app/constants/pricing.constants';
import { CurrencyPipe } from 'src/app/pipes';

@Component({
  selector: 'app-credit-purchase-popup',
  templateUrl: './credit-purchase-popup.component.html',
  styleUrls: ['./credit-purchase-popup.component.scss']
})
export class CreditPurchasePopupComponent {

  reportId: string = '';
  basePrice: number = PricingConstant.PRICE_PER_REPORT;
  credit: number = 1;

  constructor(public bsModalRef: BsModalRef,
    private router: Router,
    public currencyPipe: CurrencyPipe) { }

  gotoBillingPage() {
    this.bsModalRef.hide();
    this.router.navigateByUrl(`report/payment/checkout/${PricingPlanType.REPORT_PURCHASE}/${this.reportId}`);
  }

  cancel() {
    this.bsModalRef.hide();
  }

  decreasePercent(): void {
    this.credit = this.credit ? Number(this.credit.toString()) : 1;
    if(this.credit > 1)
      this.credit--;
  }

  increaseCredit(): void {
    this.credit = this.credit ? Number(this.credit.toString()) : 0;
    if(this.credit < 999)
      this.credit++;
  }

  getTotalAmount() {
    const counts = this.credit ? Number(this.credit.toString()) : 0;
    return this.basePrice * counts;
  }

}
